import { useEffect, useState } from "react";
import NotifCard from "./NotifCard";
import NotifModal from "./NotifModal";
import { data, useNavigate } from "react-router-dom";
import Spinner from "../../../Components/Loader/Spinner";
import TableLoading from "../../../Components/Loader/TableLoading";
import SVG from "../../../Components/SVG";
import { useNotificationCounts } from "../../../context/NotificationCountContext";
import { API_BASE_URL } from "../../../config/api";

export default function Container({ notif, accLoading }) {
  const navigate = useNavigate();
  const { refetchNotificationCounts } = useNotificationCounts();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [seen, setSeen] = useState(null);
  const [modalData, setModalData] = useState(null);

  useEffect(() => {
    if (notif) {
      const seenData = [];
      notif.forEach((item) => {
        seenData.push(item.is_seen); // ✅ correct
      });
      setSeen(seenData);
    }
  }, [notif]);

  const handleSeenClick = async (item) => {
    try {
      let response = await fetch(
        `${API_BASE_URL}notifications/announcements/mark-seen/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
          body: JSON.stringify({
            id: item.id,
            type: item.type,
          }),
        },
      );

      // If access token is invalid/expired → try refresh
      if (response.status === 401) {
        const refreshResponse = await fetch(
          `${API_BASE_URL}auth/trader/jwt/refresh/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              refresh: localStorage.getItem("refresh"),
            }),
          },
        );

        if (!refreshResponse.ok) {
          // refresh failed → logout
          localStorage.removeItem("access");
          localStorage.removeItem("authCredentials");
          localStorage.removeItem("refresh");
          localStorage.removeItem("role");
          localStorage.removeItem("email");
          navigate("/signin");
          return; // ⬅️ IMPORTANT
        }

        const refreshData = await refreshResponse.json();
        localStorage.setItem("access", refreshData.access);

        // retry original request with new access token
        response = await fetch(
          `${API_BASE_URL}notifications/announcements/mark-seen/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access")}`,
            },
            body: JSON.stringify({
              id: item.id,
              type: item.type,
            }),
          },
        );
      }

      // Now handle final response (either first or retried)
      if (!response.ok) {
        throw new Error(`https error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Account Data:", data);
      await refetchNotificationCounts();
    } catch (error) {
      console.error("Error fetching account data:", error);
    }
  };

  return (
    <div className="size-full overflow-y-auto p-3 sm:p-5 rounded-2xl flex flex-col gap-5 bg-zi-bg2-light dark:bg-zi-bg2-dark">
      {notif &&
        notif.map((item, i) => (
          <NotifCard
            key={i}
            isSeen={seen ? seen[i] : false}
            onClick={() => {
              setModalData(item);
              handleSeenClick(item);
              setSeen((pre) => {
                const newData = [...pre];
                newData[i] = true;
                return newData;
              });
              setIsModalOpen(true);
            }}
            data={item}
          />
        ))}
      {accLoading && (
        <div className="w-full flex justify-center items-center gap-2">
          <p className="text-[#808080]">در حال بارگذاری</p>
          <TableLoading className="text-[#808080]" />
        </div>
      )}

      {notif && notif.length === 0 && (
        <div className="w-full flex justify-center items-center flex-col gap-5">
          <p className="text-zi-text-light dark:text-zi-text-dark">
            موردی برای نمایش وجود ندارد
          </p>
          <SVG name="noData" classname="w-24 fill-cyan-500" />
        </div>
      )}

      {isModalOpen && (
        <div
          className="w-full h-full min-h-0 fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
          onClick={() => setIsModalOpen(false)}
        >
          <div
            className="w-11/12 max-w-lg max-h-full"
            onClick={(e) => e.stopPropagation()}
          >
            <NotifModal
              data={modalData}
              onClose={() => setIsModalOpen(false)}
            />
          </div>
        </div>
      )}
    </div>
  );
}
